import { Text } from "shared/components/Spor";
import { useSetTransfered } from "features/Header/PuzzelTelephone/components/CallControl/views/CallInSession/CallTransfer/TransferProvider";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const TransferredSuccessMsg = () => {
  const setTransferred = useSetTransfered();
  const { t } = useTranslation();

  useEffect(() => {
    const timeout = setTimeout(() => {
      setTransferred(false);
    }, 2000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);
  return <Text>{t("Satt videre")}</Text>;
};

export default TransferredSuccessMsg;
